/* eslint-disable import/prefer-default-export */
import Vue from "vue";

export const commonFunctions = new Vue({
  methods: {
    toggleNotification(e) {
      e.preventDefault();
      const noti = document.querySelector(".notification-wrapper");
      const back = document.querySelector(".notification-wrapper-backdrop");
      if (noti.classList.contains("shown")) {
        noti.classList.remove("shown");
        back.classList.remove("shown");
        document.body.classList.remove("modal-open");
      } else {
        noti.classList.add("shown");
        back.classList.add("shown");
        document.body.classList.add("modal-open");
      }
    },
    toggleDashboardSideBar() {
      const dash = document.querySelector(".dashboard-sidemenu");
      const backdrop = document.querySelector(".dashboard-sidemenu-backdrop");
      if (dash.classList.contains("shown")) {
        dash.classList.remove("shown");
        backdrop.classList.remove("shown");
        document.body.classList.remove("modal-open");
      } else {
        dash.classList.add("shown");
        backdrop.classList.add("shown");
        document.body.classList.add("modal-open");
      }
    },
    ToggleNoScroll() {
      if (document.body.classList.contains("no-scroll")) {
        console.log("removed");
        document.body.classList.remove("no-scroll");
      } else {
        console.log("added");
        document.body.classList.add("no-scroll");
      }
    }
  }
});
